
import { WDFormTextselect } from './wd-form-textselect';

export class WDFormOptionselect extends WDFormTextselect
{

  #value = null;

  constructor(opts)
  {
    super(opts);
    
    // Override the change listener from parent to use #value instead of data
    this.input.addEventListener('change', () =>
    {
      if (this.input.value.trim() === '') this.#value = null;
    })

    if (opts.value) this.value = opts.value;
  };

  
  get value() { 
    return this.#value; 
  };

  resetValue()
  {
    //used when the user starts typing into the search box, nulls
    //the value without calling any change triggers
    const origValue = this.#value;
    this.#value = null;
    if (origValue !== null) this.trigger('change');
  }

  set value(val)
  {
    //passed an object but it's empty
    if (val && val?.value === null || val?.value === undefined) val = null;
    
    let origVal = this.#value?.value || null;
     
    if (val === null)
    {
      this.#value = null;
      this.input.value = '';
    }
    else
    {
      const valStr = this.config.templates.value.interpolate(val);
      //passed an empty object
      if (valStr == 'null' || valStr.includes('${'))
      {
        this.#value = null;
        this.input.value = '';
      }
      else
      {
        this.#value = val;
        this.input.value = this.config.templates.label.interpolate(val);
      }
    }

    if (val !== origVal) 
    {
      this.trigger('change');
    }
  };
};

customElements.define('wd-form-optionselect', WDFormOptionselect);
